import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "lucky-spin-rule-popup" }
const _hoisted_2 = { class: "popup-main" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-title" }
const _hoisted_5 = { class: "popup-content" }
const _hoisted_6 = { class: "rule-sub-title" }
const _hoisted_7 = { class: "rule-type-list flex justify-between" }
const _hoisted_8 = ["innerHTML"]

import { ref } from 'vue';


export default {
  __name: 'Rule',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const activeIndex = ref(0);

return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('luckySpin.howToPlay')) + "?", 1),
            _withDirectives(_createVNode(_component_van_icon, {
              class: "close-icon",
              name: "clear",
              onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
            }, null, 512), [
              [_directive_audio, void 0, "close"]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('luckySpin.rule.subTitle')), 1),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
                return _createElementVNode("div", {
                  class: "rule-type-item",
                  key: index
                }, _toDisplayString(_ctx.$t(`luckySpin.rule.step.${index}`)), 1)
              }), 64))
            ]),
            _createElementVNode("div", {
              class: "rule-content",
              innerHTML: _ctx.$t(`luckySpin.rule.content`)
            }, null, 8, _hoisted_8)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

}